import { parseDescriptionQuality } from 'partner360/entities/keyInitiatives/helpers/parseDescriptionQuality'
import {
  EDescriptionQualityReason,
  TDescriptionQualityField,
} from 'partner360/entities/keyInitiatives/model/types'

import { DESCRIPTION_QUALITY_CONFIG } from './config'
import { getEmptyDescriptionQualityResult } from './helpers'
import { IDescriptionQualityResult } from './models'

export const getDefaultDescriptionQuality = (): IDescriptionQualityResult => ({
  score: DESCRIPTION_QUALITY_CONFIG.defaultValue.score,
  reasons: [...DESCRIPTION_QUALITY_CONFIG.defaultValue.reasons],
})

export const mapPersistedDescriptionQualityToResult = (
  value?: TDescriptionQualityField | null,
  description?: string | null
): IDescriptionQualityResult | null => {
  const quality = parseDescriptionQuality(value)

  if (!quality) {
    return getEmptyDescriptionQualityResult(description)
  }

  return {
    score: quality.Score,
    reasons: quality.Reasons as EDescriptionQualityReason[],
  }
}

export const serializeDescriptionQualityResult = (
  quality?: IDescriptionQualityResult | null
): string => {
  const value = quality ?? getDefaultDescriptionQuality()

  return JSON.stringify({
    Score: value.score,
    Reasons: value.reasons,
  })
}
